module.exports = __webpack_public_path__ + "static/media/Vertical.f03de25d.png";